import React, { useMemo } from 'react';
import { useGlobalStore } from '../../../../stores/global';
import { useSearchBox } from 'react-instantsearch';
import { useQuery } from '@tanstack/react-query';
import { wpApi } from '../../../../helpers/wordpress';
import { Center, Flex, Image, Spinner, Text } from '@chakra-ui/react';
import { graphql, navigate, useStaticQuery } from 'gatsby';

const WordpressHits = () => {
  const data = useStaticQuery(graphql`
    query {
      allBuilderModels {
        oneConfig {
          data {
            featuredArticleId
          }
        }
      }
    }
  `);
  const { setShowSearch } = useGlobalStore(state => state);
  const { query } = useSearchBox();
  const { data: featured } = useQuery(
    [
      'featured_article',
      data?.allBuilderModels?.oneConfig?.data?.featuredArticleId
    ],
    async () =>
      wpApi(
        `posts/${data?.allBuilderModels?.oneConfig?.data?.featuredArticleId}&_embed`
      ),
    {
      enabled: !!data?.allBuilderModels?.oneConfig?.data?.featuredArticleId,
      refetchOnWindowFocus: false
    }
  );
  const { data: article, isLoading } = useQuery(
    ['search_articles', query],
    async () => wpApi(`search?search=${query}&per_page=1&page=1&_embed`, 'GET'),
    {
      enabled: !!query
    }
  );

  const featuredArticle = useMemo(() => {
    let _article = null;
    if (query) {
      if (article?.response?.length > 0)
        _article = article.response[0]._embedded.self[0];
    } else if (featured) {
      _article = featured.response;
    }
    return _article;
  }, [query, article, featured]);

  const { data: media, isLoading: fetchingMedia } = useQuery(
    ['search_media', featuredArticle],
    async () => wpApi(`media/${featuredArticle.featured_media}`, 'GET'),
    {
      enabled: !!featuredArticle
    }
  );

  const navigateHandler = url => {
    setShowSearch(false);
    navigate(url);
  };

  return (
    <section className="grid-wp">
      {!!query && isLoading && (
        <Center>
          <Spinner size={'xs'} color="teal" />
        </Center>
      )}
      {featuredArticle && featuredArticle?.data?.status !== 404 && (
        <>
          <p className="title mt-6">articles</p>
          <Flex
            role="button"
            tabIndex={0}
            onClick={() => navigateHandler(`/blog/${featuredArticle.slug}`)}
            className="default-hover"
            align={'center'}
            gap={6}
            p={2}
          >
            {fetchingMedia ? (
              <Center>
                <Spinner size={'xs'} color="teal" />
              </Center>
            ) : (
              <Image
                m={0}
                w={'95px'}
                h={'62px'}
                rounded={'md'}
                flexShrink={0}
                src={media?.response?.source_url ?? ''}
                alt=""
              />
            )}

            <Text
              noOfLines={2}
              dangerouslySetInnerHTML={{
                __html:
                  featuredArticle?.title?.rendered ?? featuredArticle.title
              }}
            ></Text>
          </Flex>
        </>
      )}
    </section>
  );
};

export default WordpressHits;
